import dayjs from 'dayjs';
import type Authorization from '$provider/models/Authorization';
import type DateString from '$shared/models/DateString';
import globalAlert from '$shared/stores/globalAlertStore';
import { sentry } from '$shared/helpers/logger/sentry';
import { ServiceException } from '$shared/exceptions/ServiceException';

const TimeDelay = 1 * 60 * 1000; // 2Do optimise polling time

class SessionExpireService {
  private authorization: Authorization;
  private timer: NodeJS.Timeout | null;

  public init(authorization: Authorization) {
    this.authorization = authorization;
    this.startTimer();
  }

  public clearTimer(): void {
    this.timer && clearTimeout(this.timer);
    this.timer = null;
  }

  private startTimer(): void {
    try {
      const poll = (): void => {
        if (!this.authorization?.expireDate) {
          return;
        }
        let continuePolling = true;
        const expireDate: DateString = this.authorization.expireDate;
        const diffMin: number = dayjs(expireDate?.getRawString()).diff(dayjs().format(), 'm');

        let alertMessage = '';

        if (diffMin === 5) {
          alertMessage = 'Current session expires in 5 minutes';
          continuePolling = false;
        } else if (diffMin === 10) {
          alertMessage = 'Current session expires in 10 minutes';
        } else if (diffMin === 30) {
          alertMessage = 'Current session expires in 30 minutes';
        }

        alertMessage && globalAlert.show({ message: alertMessage, closable: true });
        this.clearTimer();
        if (continuePolling) {
          this.timer = setTimeout(() => {
            poll();
          }, TimeDelay);
        }
      };
      poll();
    } catch (err) {
      const exception = ServiceException.from('SessionExpireService', 'startTimer', {}, err, {
        authorization: this.authorization
      });
      sentry.log(exception);
    }
  }
}

export default new SessionExpireService();
